module.exports = __webpack_public_path__ + "img/fur_coats.a5cefb88.png";